var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import fr from "vee-validate/dist/locale/fr.json";
import { getUrl, Langs, urls } from "./urls";
var FR = Langs.fr;
export var fr_mad = {
    banner: "En raison d'une réorganisation en cours au sein de notre institution, nous ne sommes temporairement pas en mesure de traiter vos demandes de recherche ou de mettre à disposition nos collections (à l'exception des partenariats actuellement actifs).<br><br>Nous vous remercions de votre compréhension et vous tiendrons informé.e.s dès que nos services seront à nouveau disponibles.",
    // "<br>Merci de votre compréhension.",
    generic: {
        country: 'Pays',
        siteInstitutionel: 'Site institutionnel',
        title: "Gestion des demandes",
        titleTicket: 'Mes demandes',
        makeTicket: 'Faire une demande',
        goToForms: 'Vue standard',
        goToFormList: 'Liste des formulaires',
        myProfile: 'Mon profil',
        modifyProfile: 'Modifier mon profil',
        homepage: 'Accueil',
        noResult: 'Aucun résultat',
        visibility: 'Visibilité',
        removeFilter: 'Enlever les filtres',
        show: 'Afficher',
        elements: 'élements',
        informationLine1: 'Affichage de l’élément',
        informationLine2: 'à',
        informationLine3: 'sur',
        informationLine4: 'éléments',
        informationLine5: '(filtré de',
        informationLine6: 'éléments au total)',
        tableTitle: 'Titre',
        tableCategory: 'Type',
        tableGroup: 'Groupe',
        tableStatus: 'Statut',
        tableAction: 'Voir la demande',
        showTicket: 'Demande',
        showTicketLabel1: 'Titre : ',
        showTicketLabel2: 'Type : ',
        showClose: 'La demande est close.',
        showNotBelong: 'Vous n’avez pas accès à cette demande',
        messageBy: 'Par',
        messageTo: 'à',
        editorSend: 'Envoyer la réponse',
        editorSendPrivate: 'Message interne',
        editorSendFiles: 'Envoyer les fichiers sélectionnés',
        createTitle: 'Déposer une demande',
        notifications: 'notification | notifications',
        inscription: 'Inscription',
        connexion: 'Connexion',
        connexionAdmin: 'Connexion interne CS',
        username: 'Nom d’utilisateur·rice',
        email: 'E-mail',
        password: 'Mot de passe',
        csUser: 'Utilisateur·rice CS',
        passwordConfirm: 'Confirmation du mot de passe',
        remember: 'Se souvenir de moi',
        connect: 'Se connecter',
        passwordForgot: 'Mot de passe oublié ?',
        register: 'Créer un nouveau compte',
        emailResetPassword: 'Réinitialiser le mot de passe',
        emailAddress: 'Adresse e-mail',
        emailSend: 'Envoyer',
        resetConfirmPassword: 'Confirmer le mot de passe',
        registerUserTitle: 'Créer un compte Cinémathèque suisse',
        registerTitle: 'Inscription',
        editCustomerTitle: 'Éditer un compte client·e',
        registerCustomerTitle: 'Créer un compte client·e',
        registerFirstName: 'Prénom',
        registerLastName: 'Nom',
        phone: 'Téléphone',
        phonecode: 'Indicatif',
        statusFiaf: 'Status FIAF',
        fiaf: 'Membre FIAF',
        deliveryAddress: 'Adresse de livraison',
        billingAddress: 'Adresse de facturation',
        sameAddress: 'Même adresse',
        differentAddress: 'Adresse de facturation différente',
        city: 'Ville',
        streetName: 'Rue',
        streetNumber: 'No°',
        zipCode: 'NPA',
        companyName: 'Nom de la société',
        registerSend: 'Confirmer',
        verifyMail: 'Vérifiez votre adresse e-mail',
        verifyNewLink: 'Un nouveau lien de vérification a été envoyé.',
        verifyText: 'Avant de poursuivre, veuillez consulter vos e-mails et cliquer sur le lien de vérification afin d’activer votre compte. Si vous n’avez pas reçu d’e-mail.',
        verifyClick: 'Cliquez ici pour en demander un nouveau',
        back: 'Retour',
        close: 'Fermer',
        fillFields: 'Veuillez remplir les champs',
        infos: 'Informations',
        selectOption: 'Choisir une option',
        dateTimeFormat: 'fr',
        yes: 'oui',
        no: 'non',
        dateLabels: {
            labelPrevDecade: 'Décennie précédente',
            labelPrevYear: 'Année précédente',
            labelPrevMonth: 'Mois précédent',
            labelCurrentMonth: 'Mois en cours',
            labelNextMonth: 'Mois prochain',
            labelNextYear: 'Année prochaine',
            labelNextDecade: 'Prochaine décennie',
            labelToday: 'Aujourd’hui',
            labelSelected: 'Date choisie',
            labelNoDateSelected: 'Aucune date',
            labelCalendar: 'Calendrier',
            labelNav: 'Navigation dans l’agenda',
            labelHelp: 'Utilisez les touches fléchées pour naviguer dans le calendrier'
        },
        timeLabels: {
            labelHours: 'Heures',
            labelMinutes: 'Minutes',
            labelSeconds: 'Secondes',
            labelIncrement: 'Augmenter',
            labelDecrement: 'Diminuer',
            labelSelected: 'Heure choisie',
            labelNoTimeSelected: 'Aucune heure choisie',
            labelCloseButton: 'Fermer'
        },
        filePicker: {
            label: 'Joindre un fichier',
            button: 'Joindre fichier(s)',
            placeholder: 'Aucun fichier sélectionné',
            text1: "Utilisez le sélecteur de fichier pour envoyer jusqu'à 10 fichiers d'un maximum de 25 MB par message. Les formats suivants sont acceptés: doc, docx, xls, xlsx, pdf, txt, rtf, odt, ods, jpeg, jpg, png, zip",
            sentFileListText: 'Fichiers envoyés:',
            tooBig: "La taille maximale des fichiers pour l'envoi a été dépassée. Veuillez envoyez au maximum 25 MB de fichiers.",
            specialCharacterWarning: "Veuillez enlever les caractères spéciaux (exemple: apostrophe (\"Vente d\'images.pdf\" renommé \"Vente d_images.pdf\")) dans le nom des fichiers et veuillez ressayer",
        },
        billingDetails: {
            text1: "Coordonnées de facturation",
            alttext1: "Coordonnées",
            text2: 'Société / établissement / entreprise / privé *',
            text3: 'Rue *',
            text4: 'Numéro de rue *',
            text5: 'Code Postal *',
            text6: 'Ville *',
            text7: 'Pays *',
            text8: 'Personne de contact',
            text9: 'Prénom *',
            text10: 'Nom *',
            text11: 'Indicatif *',
            text12: 'Numéro de téléphone *',
            text13: 'Adresse e-mail *',
        },
        shippingDetails: {
            text1: "Coordonnées de livraison",
            alttext1: "Localisation du versement",
            text2: 'Société / établissement / entreprise / privé *',
            text3: 'Rue *',
            text4: 'Numéro de rue *',
            text5: 'Code Postal *',
            text6: 'Ville *',
            text7: 'Pays *',
            text8: 'Personne de contact',
            alttext8: 'Personne de contact – responsable logistique',
            text9: 'Prénom *',
            text10: 'Nom *',
            text11: 'Indicatif *',
            text12: 'Numéro de téléphone *',
            text13: 'Adresse e-mail *',
        },
        searchedFilm: {
            text1: 'Film recherché',
            text2: 'Prénom réalisateur·rice',
            text3: 'Nom réalisateur·rice',
            text4: 'Titre original / titre français *',
            text5: 'Vous serez informé·e des possibilités de visionnement en fonction du matériel à disposition. Le cas échéant, le visionnement pourra être agendé par la suite.',
            text6: 'Année de production',
            text7: 'Nombre de films recherchés',
        }
    },
    notification: {
        action: 'Consulter: ',
        contributor: "Le r\u00F4le d'intervenant vous a \u00E9t\u00E9 assign\u00E9",
        responsible: "Le r\u00F4le de responsable vous a \u00E9t\u00E9 assign\u00E9",
        message: 'Vous avez un nouveau message',
    },
    requests: {
        text1: 'Quel est votre projet?',
        text2: 'La Cinémathèque suisse collecte, conserve, étudie et met en valeur le patrimoine cinématographique suisse et international. En tant que pôle national de compétences, l’institution met différentes ressources à la disposition des publics; du secteur privé; des communauté scientifique, académique et professionnelle. Vous trouverez les ressources disponibles et leurs modalités d’accès ci-dessous.',
        text3: 'La Cinémathèque suisse ne répond pas aux questions générales sur l’histoire du cinéma.',
        menu1: 'Accéder aux collections',
        menu2: 'Sortir du matériel déposé',
        menu3: 'Organiser une projection',
        menu4: 'Découvrir la Cinémathèque suisse',
        menu5: 'Donner ou déposer du matériel'
    },
    requestsAccessCollection: {
        menu1: 'Collections film',
        menu2: 'Bibliothèque',
        menu3: 'Fonds d’archives et dossiers documentaires',
        menu4: 'Collections iconographiques et muséales',
        menu5: 'Informations sur les collections',
    },
    requestsRequestMaterial: {
        menu1: 'Accès aux éléments déposés',
    },
    requestsOrganizeProjection: {
        menu1: 'Projeter un film de nos collections',
        menu2: 'Obtenir du matériel de promotion',
        menu3: {
            title: 'Louer une salle de projection de la Cinémathèque suisse',
            submenuPrivatePublicProjection: 'Location à des fins privées ou publiques',
            submenuSchoolProjection: 'Location pour projection scolaire',
            submenuCsCollaborationProjection: 'Projections en collaboration avec la Cinémathèque suisse',
        },
    },
    requestsSubmitMaterial: {
        menu1: 'Dons et dépôts',
        menu2: 'Dépôt de films soutenus par l’OFC et/ou d’autres fonds régionaux',
    },
    requestsAccessCollection1: {
        text1: 'La Cinémathèque suisse rassemble dans ses collections Film des œuvres de fiction, documentaires, films publicitaires et de commande, films de famille et films d’amateurs. L’intégralité des actualités filmées du <b>Ciné-Journal suisse</b> est également déposée dans les collections Film de la Cinémathèque suisse, qui peut en autoriser l’usage et en fournir du matériel. Le fonds du Ciné-Journal suisse est consultable en ligne gratuitement sur la plateforme de Memobase. Depuis 2012, la Cinémathèque suisse acquiert les droits d’exploitation pour les salles helvétiques d’une petite partie de sa collection, distinguée dans le catalogue de <b>Films en diffusion</b>, librement accessible sur notre site institutionnel.',
        text2: "Le Catalogue g\u00E9n\u00E9ral des <b>collections Film</b> est quant \u00E0 lui inaccessible au public, mais la Cin\u00E9math\u00E8que suisse r\u00E9pond aux demandes sp\u00E9cifiques pour le visionnement ou l\u2019\u00E9ventuelle mise \u00E0 disposition d\u2019\u00E9l\u00E9ments de ses collections, conform\u00E9ment au <a href=\"".concat(getUrl(urls.docs.d01, FR), "\" target=\"_blank\">\uD83D\uDDCER\u00E8glement et tarifs d\u2019acc\u00E8s aux copies de films</a>. Les demandes sont \u00E9tudi\u00E9es en fonction du type de mat\u00E9riel et de l\u2019\u00E9tat de celui-ci. Toute consultation sur place est exclue pour les \u0153uvres disponibles dans le commerce (supports DVD, Blu-ray ou VOD)."),
        link1: '<b>Ciné-Journal suisse</b><br><a href="https://memobase.ch/fr/recordSet/bar-001?term=cin%C3%A9-journal&context=record_sets&position=2" target="_blank">memobase.ch</a>',
        link2: '<b>Catalogue de diffusion</b><br><a href="https://www.cinematheque.ch/services/films-en-diffusion" target="_blank">cinematheque.ch/diffusion</a>',
        menu1: {
            title: 'Demande de visionnement',
            text1: 'La Cinémathèque suisse est ouverte aux chercheur·euse·s, étudiant·e·s et déposant·e·s pour le visionnement sur place – en salle de consultation au Centre de recherche et d’archivage de Penthaz – ou à distance dans certains cas, des éléments numérisés ou numériques natifs de ses collections Film. ',
            text2: '<b>Tout visionnement sur place se fait sur rendez-vous via une demande de visionnement.</b>',
            text3: "Il est \u00E9galement possible, sous certaines conditions, de visionner sur table des \u00E9l\u00E9ments photochimiques des collections. Toutefois, cette op\u00E9ration \u00E9tant tributaire de l\u2019\u00E9tat du mat\u00E9riel, du type de mat\u00E9riel et de la disponibilit\u00E9 d\u2019un technicien pour l\u2019accompagnement des op\u00E9rations, elle se fait avec un d\u00E9lai de quinze jours au minimum. Merci de vous r\u00E9f\u00E9rer au <a href=\"".concat(getUrl(urls.docs.d02, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs de consultation sur place</a>."),
            text4: 'Lorsque possible, certains documents numérisés peuvent être consultés en ligne, par un lien sécurisé.',
            button1: 'Demande de visionnement',
        },
        menu2: 'Recherche et location de copies de projection',
        menu3: {
            title: 'Vente d’extrait',
            text1: 'La Cinémathèque suisse met à disposition des extraits de films. Elle propose pour cela un service de vente d’extraits <b>limité à certains films de ses collections</b>: les films numériques ou ayant été numérisés ainsi que la collection du Ciné-Journal suisse.',
            text2: 'La Cinémathèque suisse <b>n’effectue pas de numérisations sur demande</b>. Elle travaille à la numérisation de sa collection selon un plan correspondant à une politique interne, respectant un calendrier de conservation et visant à refléter un éventail le plus large possible de l’activité cinématographique en Suisse.',
            text3: "La collection des films num\u00E9ris\u00E9s n\u2019est pas publique, except\u00E9 pour le Cin\u00E9-Journal suisse et les films du catalogue de diffusion. Merci de sp\u00E9cifier l\u2019\u0153uvre recherch\u00E9e et nous vous indiquerons si du mat\u00E9riel est disponible. La mise \u00E0 disposition d\u2019extrait(s) se fait sur devis. Merci de vous r\u00E9f\u00E9rer \u00E9galement aux <a href=\"".concat(getUrl(urls.docs.d03, FR), "\" target=\"_blank\">\uD83D\uDDCEConditions d\u00E9taill\u00E9es pour la mise \u00E0 disposition d\u2019extraits et de CJS</a>."),
            text4: '<b>Attention, pour les œuvres protégées par le droit d’auteur, l’autorisation écrite de l’ayant-droit est nécessaire avant la mise à disposition d’extraits. La mise en règle avec les ayant-droits reste la responsabilité des personnes effectuant la demande.</b>',
            button1: 'Demande d’extrait',
        },
        menu4: {
            title: 'Licence et matériel pour le Ciné-Journal suisse',
            text1: 'De 1940 à 1975, le Ciné-Journal suisse était diffusé en avant-programme dans toutes les salles de cinéma de Suisse. Les plus de 6000 reportages filmés trilingues (allemand, français et italien) ainsi produits immortalisent des instants précieux de la vie politique, sociale et culturelle de la Suisse. Moyen d’information public au service de la défense spirituelle du pays, le Ciné-Journal suisse a imprégné la mémoire audiovisuelle collective de la Suisse.',
            text2: 'Les éléments sur pellicule sont conservés à la Cinémathèque suisse et ont entièrement été numérisés. Leur consultation est possible sur memobase.ch :',
            text3: 'La Cinémathèque suisse peut fournir des extraits ou du matériel d’exploitation via le formulaire ci-dessous:',
            link1: '<a href="https://memobase.ch/fr/recordSet/bar-001?term=cin%C3%A9-journal&context=record_sets&position=2" target="_blank">memobase.ch</a>',
            // TODO test interpolation
            link2: "<a href=\"".concat(getUrl(urls.docs.d03, FR), "\" target=\"_blank\">\uD83D\uDDCEConditions d\u00E9taill\u00E9es pour la mise \u00E0 disposition d\u2019extraits et de CJS</a>"),
            button1: 'Demande de licence et de matériel pour le CJS',
        },
    },
    requestsAccessCollection2: {
        text1: "Les sites de Penthaz et de Zurich accueillent chacun des collections de bibliothèque. Leurs catalogues de monographies, scénarios et DVD sont consultables dans le réseau Renouvaud - Sciences et Patrimoine.",
        text2: 'La commande de(s) document(s) de la Bibliothèque se fait uniquement via <b>un compte lectrice ou lecteur Renouvaud ou Bibliopass</b>. Pour qui n’aurait pas de compte : remplir ce <a href="https://db-prod-bcul.unil.ch/pre-inscription/sp/post.php" target="_blank">formulaire</a> pour une inscription gratuite, qui sera validée par la CS.',
        text3: 'Le retrait des documents – que ce soit pour une consultation sur place ou pour le prêt à domicile – nécessite un rendez-vous. La Bibliothèque prend contact avec la lectrice ou le lecteur par e-mail après avoir reçu la commande.',
        link1: '<b>Catalogue Renouvaud</b><br><a href="https://cinematheque.renouvaud.ch" target="_blank">https://cinematheque.renouvaud.ch</a>',
        link2: "<a href=\"".concat(getUrl(urls.docs.d04, FR), "\" target=\"_blank\">\uD83D\uDDCER\u00E8glement d\u2019utilisation du D\u00E9partement Non-Film</a>"),
        link3: '<a href="https://www.cinematheque.ch/infos-pratiques/acces-et-horaires" target="_blank">🗎Horaires d’ouverture</a>',
    },
    requestsAccessCollection3: {
        text1: 'L’inventaire en ligne Caspar est votre première porte d’entrée pour l’accès aux collections d’archives et aux dossiers documentaires de la collection Non-Film.',
        text2: '<b>Caspar ne donne pas accès à des archives numérisées.</b> La consultation des archives physiques se fait sur place uniquement, selon leur lieu de conservation :',
        text3: 'Au <b>Centre de recherche et d’archivage de Penthaz</b>',
        text4: 'Au <b>Centre de recherche et d’archivage de Zurich</b>',
        text5: 'Les <b>archives numériques</b> sont également consultables sur place, avec le lieu de consultation à choix entre Penthaz et Zurich. Merci de déposer une demande de consultation ci-dessous en renseignant si possible la cote des fonds, dossiers et documents souhaités.',
        link1: '<b>Caspar</b><br><a href="https://caspar.cinematheque.ch" target="_blank">caspar.cinematheque.ch</a>',
        link2: "<a href=\"".concat(getUrl(urls.docs.d04, FR), "\" target=\"_blank\">\uD83D\uDDCER\u00E8glement d\u2019utilisation du D\u00E9partement Non-Film</a>"),
        link3: '<a href="https://www.cinematheque.ch/infos-pratiques/acces-et-horaires" target="_blank">🗎Horaires d’ouverture</a>',
        button1: 'Demande de consultation sur place, de rendez-vous ou de renseignement',
    },
    requestsAccessCollection4: {
        text1: 'Les collections iconographiques et muséales de la Cinémathèque suisse rassemblent photographies, affiches, diapositives, appareils cinématographiques et des objets de «pré-cinéma ».',
        text2: "<b>Un travail de mise en ligne du catalogue des collections et un acc\u00E8s aux documents num\u00E9ris\u00E9s et num\u00E9riques natifs sont en cours de d\u00E9veloppement.</b> Il est dans tous les cas possible d\u2019adresser une demande de recherche dans les collections. Merci de vous r\u00E9f\u00E9rer au pr\u00E9alable \u00E0 nos <a href=\"".concat(getUrl(urls.docs.d05, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs</a> et de prendre connaissance de nos <a href=\"").concat(getUrl(urls.docs.d06, FR), "\" target=\"_blank\">\uD83D\uDDCEConditions d\u2019utilisation des images</a> mises \u00E0 votre disposition."),
        text3: 'Pour certaines demandes (projets de recherches, expositions, publications), il vous sera proposé une consultation sur place ou à distance ainsi qu’un échange avec un·e documentaliste pour préciser votre besoin.',
        text4: '<b>Attention, la recherche de l’ayant-droit et le règlement des droits d’utilisation d’images fixes sont à la charge des personnes effectuant la demande.</b>',
        button1: 'Demande d’images fixes',
        button2: 'Demande de consultation sur place, de rendez-vous ou de renseignement',
    },
    requestsAccessCollection5: {
        text1: "Pour acc\u00E9der aux bases de donn\u00E9es publi\u00E9es \u2013 selon la <a href=\"".concat(getUrl(urls.docs.d09, FR), "\" target=\"_blank\">\uD83D\uDDCEPolitique de collection</a> de la Cin\u00E9math\u00E8que suisse, merci de vous r\u00E9f\u00E9rer aux outils de recherche \u00E0 votre disposition, pr\u00E9sent\u00E9s dans les pages correspondantes :"),
        text2: 'Dans le cadre de projets de recherche, de projets d’exposition ou de toute autre <b>demande spécifique</b> d’informations sur les collections de la Cinémathèque suisse (recherches documentaires non liées à une prestation de mise à disposition), vous pouvez déposer une demande d’informations sur les collections ci-dessous, sans garanties. Selon le type de demandes, une consultation sur place de la base de données film est envisageable, sur rendez-vous. Dans la mesure du possible, merci d’indiquer toute référence disponible (fonds, cotes) ou une filmographie exhaustive.',
        text3: '<b>La Cinémathèque suisse se réserve le droit de refuser le traitement de demandes d’informations sur les collections.</b>',
        link1: 'Collections Film',
        link2: 'Bibliothèque de la Cinémathèque suisse',
        link3: 'Fonds d’archives et dossiers documentaires',
        link4: 'Collections iconographiques et muséales',
        button1: 'Demande d’informations sur les collections',
    },
    requestsRequestMaterial1: {
        text1: '<b>Matériel film</b>',
        text2: "En fonction des modalit\u00E9s de d\u00E9p\u00F4t, les d\u00E9posant\u00B7e\u00B7s sont autoris\u00E9\u00B7e\u00B7s \u00E0 demander la <b>sortie provisoire de copies de projection</b> ou l\u2019<b>acc\u00E8s au mat\u00E9riel d\u00E9pos\u00E9</b>, en adressant une demande \u00E0 la Cin\u00E9math\u00E8que suisse par \u00E9crit via les formulaires ci-dessous.",
        text3: "Pour les d\u00E9posant\u00B7e\u00B7s et distributeur\u00B7rice\u00B7s suisses, la sortie de copies de projection se fait avec un d\u00E9lai de 2 semaines au minimum, pour un envoi en Suisse. Les d\u00E9lais pour d\u2019autres types de sorties de mat\u00E9riel film varient selon la nature de la demande. Merci de vous r\u00E9f\u00E9rer aux <a href=\"".concat(getUrl(urls.docs.d07, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs de mise \u00E0 disposition pour d\u00E9posants</a>."),
        text4: '<b>Matériel non-film</b>',
        text5: 'Les déposant·e·s peuvent obtenir l’accès ou demander la sortie provisoire du matériel non-film déposé via le formulaire de consultation sur place. Merci de spécifier votre besoin et de mentionner votre statut de déposant·e dans le descriptif de la demande.',
        button1: 'Ordre de sortie pour projection',
        button2: 'Accès au matériel film déposé',
        button3: 'Demande de consultation sur place, de rendez-vous ou de renseignement',
    },
    requestsOrganizeProjection1: {
        text1: '<b>Catalogue de diffusion</b>',
        text2: 'La Cinémathèque suisse détient les droits d’exploitation pour la Suisse – et pour l’étranger dans certains cas – de près de 200 films, comprenant films du patrimoine généralement restaurés et films d’auteurs contemporains. Accessible au public, ce catalogue de films dit “de diffusion” est votre première porte d’entrée pour l’accès aux collections Film.',
        text3: '<b>Collections film</b>',
        text4: 'A l’image de toutes les cinémathèques du monde, notre catalogue des collections Film n’est pas accessible au public. La Cinémathèque suisse répond toutefois aux demandes précises, pour la consultation ou l’éventuelle mise à disposition de copies de projection. Cette pratique – appliquée par les membres de la FIAF (Fédération internationale des archives du film) – obéit à des clauses de confidentialité vis-à-vis des déposant·e·s et à des considérations d’ordre juridique.',
        text5: "<b>Toute demande de copie de film s\u2019effectue via le formulaire ci-dessous.</b> Dans le cas o\u00F9 le titre souhait\u00E9 fait partie du catalogue de diffusion, vous en serez inform\u00E9\u00B7e et les droits pourront \u00EAtre r\u00E9gl\u00E9s directement aupr\u00E8s de la Cin\u00E9math\u00E8que suisse. Sinon, il vous sera demand\u00E9 de fournir l\u2019accord pr\u00E9alable des ayants-droit avant toute sortie de mat\u00E9riel. Merci de vous r\u00E9f\u00E9rer au <a href=\"".concat(getUrl(urls.docs.d01, FR), "\" target=\"_blank\">\uD83D\uDDCER\u00E8glement et tarifs d\u2019acc\u00E8s aux copies de films</a> ou encore aux <a href=\"").concat(getUrl(urls.docs.d08, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs des films au catalogue de diffusion</a>."),
        text6: '<b>La Cinémathèque suisse n’effectue pas de numérisations ni de transcodage sur demande.</b>',
        link1: '<b>Catalogue de diffusion</b><br><a href="https://www.cinematheque.ch/services/films-en-diffusion" target="_blank">cinematheque.ch/diffusion</a>',
        button1: 'Demande de copie(s) de projection',
    },
    requestsOrganizeProjection2: {
        text1: '<b>Catalogue de diffusion</b>',
        text2: 'Matériel numérique',
        text3: 'Pour les films dont la Cinémathèque suisse détient les droits, les éléments de promotion numérique disponibles – affiches, images, dossiers de presse, bandes annonces DCP ou vidéo – sont librement accessibles au téléchargement sur le catalogue en ligne :',
        text4: 'Matériel imprimé',
        text5: 'Pour les exploitants helvétiques, les affiches B1 et flyers A5 des films au catalogue de diffusion peuvent être commandés via la commande de copies ou directement par le formulaire ci-dessous (sous réserve de disponibilité).',
        text6: '<b>Collections iconographiques</b>',
        text7: 'Pour rechercher du matériel de promotion indisponible dans le catalogue de diffusion en ligne, merci de faire une demande via le formulaire de demande d’images fixes ci-dessous.',
        link1: '<b>Catalogue de diffusion</b><br><a href="https://www.cinematheque.ch/services/films-en-diffusion" target="_blank">cinematheque.ch/services/films-en-diffusion</a>',
        button1: 'Diffusion - Commande d’affiches et de flyers',
        button2: 'Demande d’images fixes',
    },
    requestsOrganizeProjection3: {
        text1: '<b>Location des salles du cinéma Capitole</b>',
        text2: 'Il est possible d\'adresser des demandes de location uniquement à travers notre plateforme <a href="https://ask.cinematheque.ch" target="_blank">ask.cinematheque.ch</a>, au moyen du lien vers le formulaire ci-dessous. Compter un délai de réponse de 30 jours (délai de traitement non garanti). La Cinémathèque suisse se réserve le droit de refuser toute demande.',
        text3: 'La Cinémathèque suisse dispose de deux salles de projection au sein du cinéma Capitole:',
        text4: '<b>Salle Freddy Buache</b> - 718 places',
        text5: 'Salle historique sur deux niveaux avec parterre et balcon, la salle Freddy Buache ouvre sur des espaces bar pouvant accueillir 300 personnes au maximum.',
        text6: '<b>Salle Lucienne Schnegg</b> – 136 places',
        text7: 'Nouvellement créé lors de la rénovation du bâtiment, la salle Lucienne Schnegg comprend un espace bar et un foyer pouvant accueillir 80 personnes. La salle Lucienne Schnegg est accessible depuis l’entrée principale ou depuis l’impasse située entre la Coop et le Capitole (pas d’ascenseur dans ce cas).',
        text8: 'Un ascenseur dessert les 4 étages du bâtiment et permet l’accès aux salles et espaces d’accueil pour les personnes à mobilité réduite. Les trois espaces bar sont équipés entre autres choses de frigos et congélateurs.',
        text9: 'Les cabines de projection sont dotées d’un équipement de pointe (4K laser, son THX 7.1). Les demandes feront l’objet d’un rendez-vous technique préalable selon la nature du projet.',
        text10: '<b>Location à des fins privées ou publiques</b>',
        text11: 'Les salles et espaces d’accueil du cinéma Capitole peuvent être loués pour des événements privés ou publics, par des entreprises, associations, festivals, etc. La Cinémathèque suisse n’entre cependant pas en matière pour les demandes individuelles (particuliers).',
        text12: 'Les locations se limitent aux disponibilités des salles en fonction du programme courant de la Cinémathèque suisse. Il est possible de louer les salles pour des événements ne comportant pas de projection.',
        text13: 'Les demandes sont soumises à un délai de 60 jours.',
        text14: '<b>Location pour projections scolaire</b>',
        text15: 'La Cinémathèque suisse organise des projections scolaires sur demande, le jeudi matin dès 9h, à partir de 60 élèves. Merci de déposer une demande de location en cochant l’option « Séance scolaire ».',
        text16: 'Il est également possible d’assister à une projection du programme courant en bénéficiant de tarifs préférentiels – hors ciné-concerts. Les groupes d’élèves bénéficient d’un tarif spécial de CHF 10.- par élève et de la gratuité pour les enseignant·e·s accompagnants. Vous pouvez réserver vos places et obtenir un tarif de groupe en déposant une demande "Assister à une projection - Groupe scolaire" ci-dessous.',
        text17: '<b>Projections en collaboration avec la Cinémathèque suisse</b>',
        text18: 'Les demandes de location pour des événements comprenant une projection publique peuvent faire l’objet d’une demande de partenariat afin d’être intégrées dans le programme bimestriel de la Cinémathèque suisse. Compte tenu des impératifs de programmation, les demandes de partenariat sont à déposer au plus tôt, dans l’idéal six mois à l’avance. L’acceptation des demandes de partenariat est à l’entière discrétion de la CS.',
        button3: 'Demande de location',
        button4: 'Demande de location',
        button5: 'Assister à une projection - Groupe scolaire',
        button6: 'Demande de partenariat',
    },
    requestsDiscoverCS1: {
        menuTitle: 'Expositions virtuelles et timeline',
        text1: '<b>Expositions virtuelles</b>',
        text2: 'En complément aux expositions physiques organisées en collaboration avec des musées, festivals et autres institutions, la Cinémathèque suisse propose des expositions thématiques en ligne rassemblant des documents emblématiques et souvent inédits, qui mettent en valeur différents mouvements artistiques, genres ou cinéastes suisses et étrangers.',
        text3: '<b>Programme à venir</b>',
    },
    requestsDiscoverCS2: {
        menuTitle: 'Visiter le Centre de recherche et d’archivage de Penthaz',
        text1: 'La Cinémathèque suisse organise des visites de son Centre de recherche et d’archivage de Penthaz pour des groupes à partir de 10 personnes. Les visites se font sur réservation et peuvent être adaptées à différents types de publics. Elles durent environ 2h.',
        text2: '<b>Groupes scolaires et groupes d’enfants</b>',
        text3: 'Les visites pédagogiques se focalisent sur la découverte ludique des missions et métiers de la Cinémathèque suisse.',
        text4: '<b>Groupes privés et/ou institutionnels</b>',
        text5: 'La Cinémathèque suisse propose une visite dite classique. En fonction des disponibilités des collaborateur·rices·s, il est également possible d’axer une visite sur des aspects particuliers.',
        text6: '<b>Pour des raisons de planification et de ressources limitées, toute demande de visite doit être déposée au moins 3 mois à l’avance.</b>',
        button1: 'Réservation d’une visite - Penthaz',
    },
    requestsDiscoverCS3: {
        menuTitle: 'Visiter le Centre de recherche et d’archivage de Zurich',
        text1: 'La Cinémathèque suisse organise des visites de son Centre de recherche et d\'archivage de Zurich. Les visites se font sur réservation et peuvent être adaptées à différents types de publics. Elles durent environ 2h.',
        text2: 'En fonction des disponibilités des collaborateurs et collaboratrices, il est possible d’axer une visite du Centre de recherche et d\'archivage de Zurich sur des aspects particuliers de ses collections. N’hésitez pas à faire part de tout souhait lors de la réservation.',
        button1: 'Réservation d’une visite - Zurich',
    },
    requestsDiscoverCS4: {
        menuTitle: 'Assister en groupe à une projection du programme',
        text1: 'La Cinémathèque suisse propose des projections au Capitole du mardi au dimanche.',
        text2: '<b>Accès et horaires Café-Billetterie du Capitole</b>',
        text2subtext1: 'Lundi: Fermé',
        text2subtext2: 'Mardi - Samedi: 13:30 - 20:30*',
        text2subtext3: 'Dimanche: 14:00 - 20:30*',
        text2subtext4: '*En cas d’horaire spécial, le café-billetterie du Capitole ouvre 30 minutes avant le début de la première séance.',
        text3: 'Le programme des projections et la billetterie sont également accessibles en ligne, à l’adresse :',
        text4: '<b>Réservations pour groupe privé ou scolaire </b>',
        text5: 'À partir de 10 personnes, il est possible d’assister à une projection en bénéficiant de tarifs préférentiels – hors séances spéciales et avant-premières. Les groupes d’élèves des degrés primaire et secondaire II bénéficient également d’un tarif spécial de CHF 5.- par élève et de la gratuité pour les enseignant·e·s qui accompagnent le groupe. Vous pouvez réserver vos places et obtenir un tarif de groupe en déposant la demande de réservation adéquate ci-dessous.',
        link1: '<a href="https://live.cinematheque.ch" target="_blank">live.cinematheque.ch</a>',
        button1: 'Groupe privé',
        button2: 'Groupe scolaire',
    },
    requestsSubmitMaterial1: {
        text1: 'Vos versements volontaires nous permettent d’enrichir en permanence les collections de la Cinémathèque suisse.',
        text2: '<b>Nouveaux versements dans les collections</b>',
        text3: 'Chaque demande – hors dépôts faisant déjà l’objet d’accords avec la Cinémathèque suisse – fait l’objet d’un examen préalable.',
        text4: "Les versements sont accept\u00E9s \u00E0 condition qu\u2019ils correspondent aux crit\u00E8res de la <a href=\"".concat(getUrl(urls.docs.d09, FR), "\" target=\"_blank\">\uD83D\uDDCEPolitique de collection</a> de la Cin\u00E9math\u00E8que suisse. En vertu de cette politique, il est possible que des propositions de don ou de d\u00E9p\u00F4t soient refus\u00E9es, en partie ou dans leur totalit\u00E9. Merci de faire une demande de don ou d\u00E9p\u00F4t ci-dessous et de <b>ne pas transmettre de mat\u00E9riel tant que nous n\u2019aurons pas valid\u00E9 votre demande</b>."),
        text5: 'Le traitement et le stockage de lots de matériel volumineux peuvent être soumis à des accords spécifiques impliquant des frais de traitement et des frais de stockage, sur devis.',
        text6: 'La Cinémathèque suisse se réserve le droit de faire un premier tri en jetant les éléments inutilisables, trop dégradés et/ou présentant un danger pour les collections.',
        text7: "Pour les d\u00E9p\u00F4ts num\u00E9riques, merci de vous r\u00E9f\u00E9rer aux <a href=\"".concat(getUrl(urls.docs.d10, FR), "\" target=\"_blank\">\uD83D\uDDCEModalit\u00E9s de d\u00E9p\u00F4ts num\u00E9riques</a> \u00E0 la Cin\u00E9math\u00E8que suisse."),
        text8: '<b>Dépôts obligatoires (dépôts OFC ou films soutenus par d’autres fonds régionaux)</b>',
        text9: 'Merci de vous référer à la page dédiée :',
        link1: 'Dépôt de films soutenus par l’OFC et/ou d’autres fonds régionaux',
        button1: 'Donner ou déposer du matériel',
    },
    requestsSubmitMaterial2: {
        text1: 'Conformément à l’<a href="https://www.fedlex.admin.ch/eli/cc/2016/291/fr" target="_blank">article 63 de l’Ordonnance du Département fédéral de l’intérieur (DFI) sur l’encouragement du cinéma (OECin)</a> du 21 avril 2016 , le ou la bénéficiaire d’une aide financière fédérale à la réalisation est tenu.e de faire parvenir à la fondation Cinémathèque suisse (CS) les fichiers de base ayant servi à la production de la version finale du film (masterfile). Les œuvres soutenues par d’autres fonds régionaux (cinéforom, Berner Filmförderung, Zürcher Filmstiftung, etc.) sont également soumises à cette obligation, selon les statuts et accords en vigueur.',
        text2: 'Dans le cadre de ces soutiens, le mandat de la Cinémathèque suisse est de conserver votre production sur le long terme dans sa qualité maximale d’origine. En déposant votre matériel, vous assurez sa pérennité dans le futur. La Cinémathèque suisse collecte également le matériel d’exploitation lié aux films qu’elle conserve. Ces objets sont pris en charge par le Département Non-Film.',
        text3: '<b>Marche à suivre pour le dépôt de films ayant reçu un soutien de l’OFC ou d’un autre fonds régional :</b>',
        text4: "Remplissez la <a href=\"".concat(getUrl(urls.docs.d11, FR), "\" target=\"_blank\">\uD83D\uDDCEConfirmation de d\u00E9p\u00F4t pour archivage</a> (version italienne disponible <a href=\"").concat(getUrl(urls.docs.d11, Langs.it), "\">\uD83D\uDDCEici</a>)."),
        text5: "Assurez-vous que le mat\u00E9riel est conforme aux <a href=\"".concat(getUrl(urls.docs.d12, FR), "\" target=\"_blank\">\uD83D\uDDCESp\u00E9cifications techniques pour le d\u00E9p\u00F4t obligatoire d\u2019\u00E9l\u00E9ments de film num\u00E9riques</a> (version italienne disponible <a href=\"").concat(getUrl(urls.docs.d12, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEici</a>)."),
        text6: 'Envoyez le matériel à la Cinémathèque suisse, avec l’adresse d’expéditeur, à :<br><br><b>Cinémathèque suisse<br>Centre de recherche et d’archivage<br>Département Film / Dépôt obligatoire<br>Chemin de La Vaux 1<br>1303 Penthaz</b><br><br><b>Si cela est possible, joignez à l’envoi 6 exemplaires de chaque élément de promotion imprimé disponible (affiches, flyers, photos d´exploitation, cartes postales).</b>',
        text7: 'La Cinémathèque suisse vous informe que le dépôt est conforme aux demandes et le valide auprès de l’OFC et/ou des organismes concernés.',
        text8: 'Si vous acceptez de nous transmettre le matériel de promotion numérique pour archivage, l’équipe de la Cinémathèque suisse prendra contact avec vous pour son acquisition.',
    },
    formViewingRequest: {
        text1: 'Demande de visionnement',
    },
    formViewingRequest1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Motif de la demande',
        text4: 'Descriptif de votre demande et description de l’oeuvre recherchée si le titre n’est pas connu',
        text5: 'Motif de la demande / description du travail de recherche :<br><ul><li>Thème</li><li>Institution</li><li>Publication prévue</li><li>...</li></ul>',
    },
    formViewingRequest2: {
        text1: 'Film recherché',
        text2: 'Prénom réalisateur·rice',
        text3: 'Nom réalisateur·rice',
        text4: 'Titre original / titre français *',
        text5: 'Vous serez informé·e des possibilités de visionnement en fonction du matériel à disposition. Le cas échéant, le visionnement pourra être agendé par la suite.',
        text6: 'Année de production',
        text7: 'Nombre de films recherchés',
    },
    formViewingRequest3: {
        text1: 'Version de copie souhaitée',
        text2: 'En fonction des disponibilités :<br><ul><li>VO s-t. Français</li><li>VO s-t. Allemand</li><li>VO s-t. Italien</li><li>Autre</li></ul>Si Autre, saisir la version souhaitée.<br><br>Nous essaierons dans la mesure du possible de vous proposer du matériel dans la version sélectionnée. Si cela n’est pas possible, vous en serez informé·e et nous vous indiquerons si d’autre versions sont éventuellement disponibles.',
    },
    formViewingRequest4: {
        text1: 'Remarques',
        text2: 'Merci de saisir ici toute remarque ou spécificité n’ayant pas été prise en compte dans le formulaire.',
    },
    formViewingRequest5: {
        text1: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d02, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs de consultation sur place</a> *"),
        text2: 'Envoyer la demande',
    },
    formViewingRequest6: {
        text1: 'Aucune prestation payante ne sera fournie sans une confirmation préalable de votre part.<br><br>' +
            "Pour les client·e·s hors Suisse, les paiements s'effectuent d'avance, sur facture.",
    },
    formClipRequest: {
        text1: 'Demande d’extrait',
    },
    formClipRequest1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande *',
        text4: 'Descriptif de votre demande',
        text5: 'Pour le Ciné-journal suisse, veuillez vous référer au  <a href="/forms/cine-journal">formulaire dédié</a>.<br><br>Le délai de réponse est de 10 jours ouvrés.<br><br>Suite au dépôt de votre demande, nous vous transmettrons un devis pour les extraits demandés, si disponibles.<br><br>En cas de réponse positive et après confirmation de votre part, la fabrication et la livraison des fichiers nécessiteront <b>4 à 6 semaines de délai supplémentaire</b>.',
    },
    formClipRequest2: {
        text1: 'Oeuvre concernée',
        text2: 'Prénom réalisateur·rice',
        text3: 'Nom réalisateur·rice',
        text4: 'Titre original / titre français',
        text5: 'Avant livraison de tout extrait de film, l’autorisation préalable de l’ayant-droit devra être fournie par la personne effectuant la demande. La consultation de certains éléments restaurés / numérisés est possible sur <a href="https://memobase.ch/fr/search?filter[institution][0]=Cin%C3%A9math%C3%A8que%20suisse" target="_blank">Memobase</a> et <a href="http://www.archimob.ch/" target="_blank">Archimob</a>.',
    },
    formClipRequest3: {
        text1: 'Territoire d’utilisation',
        text2: {
            option1: 'Suisse',
            option2: 'Europe',
            option3: 'Monde',
        },
        text3: 'Type d’utilisation',
        text4: {
            option1: 'Usage privé',
            option2: 'Travail de recherche',
            option3: 'Projection publique',
            option4: 'Production audiovisuelle',
            option5: 'Exposition',
            option6: 'Autre',
        },
        text5: 'Canal de diffusion',
        text6: {
            option1: 'Broadcast',
            option2: 'Web',
            option3: 'Vod',
            option4: 'Cinéma',
            option5: 'Installation',
            option6: 'Autre',
        },
    },
    formClipRequest4: {
        text1: 'Remarques',
    },
    formClipRequest5: {
        text1: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d03, FR), "\" target=\"_blank\">\uD83D\uDDCEConditions d\u00E9taill\u00E9es pour la mise \u00E0 disposition d\u2019extraits et de CJS</a>"),
        text2: 'Envoyer la demande',
    },
    formCineJournal: {
        text1: 'Licence et matériel vidéo du Ciné-Journal suisse',
    },
    formCineJournal1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande',
        text4: 'Motif ou description du projet d’utilisation des images',
        text5: 'Suite au dépôt de votre demande, nous vous transmettrons un devis avec les prestations demandées.<br><br>Les délais de traitement sont de 4 à 6 semaines au minimum.',
    },
    formCineJournal2: {
        text1: 'Ciné-Journal suisse concerné',
        text2: 'N° de référence',
        text3: 'Titre du sujet *',
        text4: 'J’ai également besoin d’obtenir du matériel pour ce Ciné-Journal suisse',
        text5: 'Date d’utilisation *',
        text6: 'Si vous connaissez la référence du Ciné-Journal suisse souhaité, merci de la renseigner (numéro de sujet, numéro ou date de l´édition).',
    },
    formCineJournal3: {
        text1: 'Territoire d’utilisation',
        text2: {
            option1: 'Suisse',
            option2: 'Europe',
            option3: 'Monde',
        },
        text3: 'Type d’utilisation',
        text4: {
            option1: 'Usage privé',
            option2: 'Travail de recherche',
            option3: 'Projection publique',
            option4: 'Production audiovisuelle',
            option5: 'Exposition',
            option6: 'Autre',
        },
        text5: 'Canal de diffusion',
        text6: {
            option1: 'Broadcast',
            option2: 'Web',
            option3: 'Vod',
            option4: 'Cinéma',
            option5: 'Installation',
            option6: 'Ordinateur',
        },
    },
    formCineJournal4: {
        text1: 'Remarques',
    },
    formCineJournal5: {
        text1: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d13, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs de licence et mat\u00E9riel pour le Cin\u00E9-Journal suisse</a>"),
        text2: 'Envoyer la demande',
    },
    formOnSiteConsultation: {
        text1: 'Demande de consultation sur place, de rendez-vous ou de renseignement',
    },
    formOnSiteConsultation1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande',
        text4: 'Descriptif de votre demande',
        text5: 'A Penthaz, deux salles de consultation sont à la disposition des usagers/usagères. Les locaux sont équipés d’une photocopieuse et du Wifi.<br><br>Une des salles de consultation peut être mise à disposition pour des travaux de groupe. Il est recommandé de vérifier les disponibilités lors de la prise de rendez-vous.<br><br>Le Centre de recherche et d’archivage de Penthaz dispose d’une cafétéria visiteurs avec un automate à boissons et snacks et un four à micro-ondes.',
    },
    formOnSiteConsultation2: {
        text1: 'Catégorie et description des documents souhaités pour la consultation *',
        text2: {
            option1: 'Fonds d’archives',
            placeholder1: 'Nom, thème ou cote',
            option2: 'Dossiers documentaires',
            placeholder2: 'Nom, thème ou cote',
            option3: 'Monographies, périodiques, scénarios, Blu-ray, DVD',
            placeholder3: 'Nom, thème ou cote',
            option4: 'Images fixes',
            placeholder4: 'Nom, thème ou cote',
            option5: 'Autre',
            placeholder5: 'Préciser',
        },
        text3: 'Nom, thème ou cote',
        text4: 'Préciser',
        text5: 'Au minimum une catégorie',
    },
    formOnSiteConsultation3: {
        text1: 'Consultation de documents numériques',
        text2: {
            option1: 'Centre de recherche et d’archivage de Penthaz',
            option2: 'Centre de recherche et d’archivage de Zurich',
        },
        text3: 'Les documents numérisés peuvent être consultés à Penthaz ou Zurich. Merci de spécifier votre préférence.<br><br>La consultation de documents physiques se fait uniquement dans le lieu de conservation de ceux-ci.<br><br><b><a href="https://www.cinematheque.ch/infos-pratiques/acces-et-horaires" target="_blank"> Salles de consultation et Horaires d\'ouverture</a>',
        text4: 'Date souhaitée *',
        text5: 'Délais minimaux de 10 à 15 jours ouvrés entre le dépôt d’une demande et la 1ère date de consultation',
    },
    formOnSiteConsultation4: {
        text1: 'Remarques',
    },
    formOnSiteConsultation5: {
        text1: "J\u2019ai bien pris connaissance du <a href=\"".concat(getUrl(urls.docs.d04, FR), "\" target=\"_blank\">\uD83D\uDDCER\u00E8glement d\u00B4utilisation du D\u00E9partement Non-Film: </a>"),
        text2: 'Envoyer la demande',
    },
    formStillImages: {
        text1: 'Demande d’image(s) fixe(s)',
    },
    formStillImages1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande',
        text4: 'Film, personne, oeuvre, thème, type de documents recherchés',
        text5: 'Merci d’être le·la plus détaillé·e possible sur les images recherchées. Dans l’idéal, vous pouvez fournir une filmographie ou la référence d’un fonds d’archive.',
    },
    formStillImages2: {
        text1: 'Cadre d’utilisation',
        text2: {
            option1: 'Usage privé',
            option2: 'Travail de recherche',
            option3: 'Promotion - Projection publique',
            option4: 'Publication papier ou numérique',
            option5: 'Exposition',
            option6: 'Catalogue d’exposition',
            option7: 'Production vidéo',
            option8: 'Livres',
            option9: 'Emprunt',
            option10: 'Autre',
        },
        text3: 'La résolution des images numériques à livrer pourra être précisée ultérieurement, en fonction des éléments disponibles.<br><br>Option "Autre" : selon le format, la disponibilité du document et le nombre de documents à traiter.',
    },
    formStillImages3: {
        text1: 'Date de livraison souhaitée *',
        text2: 'Les délais minimaux sont de 10 à 15 jours ouvrés entre le dépôt d’une demande et la livraison, sans garanties, et selon le format, la disponibilité du document et le nombre de documents à traiter.',
    },
    formStillImages4: {
        text1: 'Remarques',
    },
    formStillImages5: {
        text1: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d06, FR), "\" target=\"_blank\">\uD83D\uDDCEConditions d'utilisation des images</a> *"),
        text2: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d05, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs</a> *"),
        text3: 'Envoyer la demande',
    },
    formInformationRequest: {
        text1: 'Demande d’informations sur les collections',
    },
    formInformationRequest1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande',
        text4: 'Merci de décrire votre demande et de renseigner si possible : Titre(s), personne(s), oeuvre(s), thème(s), type de documents recherchés...',
        text5: 'Merci de fournir un maximum de détails et d’indiquer toute référence disponible (fonds, cotes) ou une filmographie exhaustive.<br><br>Votre demande sera traitée dans les plus brefs délais.',
    },
    formInformationRequest2: {
        text1: 'Type de collection cible',
        text2: {
            option1: 'Collection Film',
            option2: 'Collection Non-Film',
            option3: 'Toutes les collections',
        },
        text3: 'Sur quelle collection porte votre demande ?',
    },
    formInformationRequest3: {
        text1: 'Utilisation des informations',
        text2: {
            option1: 'Projet de recherche',
            option2: 'Projet d’exposition',
            option3: 'Autre usage',
        },
        text3: 'A quel usage destinez-vous la demande d’information ?',
    },
    formInformationRequest4: {
        text1: 'Remarques',
    },
    formInformationRequest5: {
        text1: 'Envoyer la demande',
    },
    formReleaseOrder: {
        text1: 'Ordre de sortie',
    },
    formReleaseOrder1: {
        text1: 'Motif de la demande',
        text2: 'Descriptif de la demande',
        text3: 'Si nécessaire, faites une brève description de votre demande.<br><br>Le délai de traitement minimum est de 10 jours ouvrés.',
    },
    formReleaseOrder2: {
        text1: 'Fonds ou versement concerné',
        text2: 'Référence(s) (ex. Meier Hans 2020)',
        text3: 'Film concerné',
        text4: 'Prénom réalisateur·rice',
        text5: 'Nom réalisateur·rice',
        text6: 'Titre original / titre français *',
        text7: 'Version linguistique (ex. E/df)',
        text8: 'Cote CS si connue (ex. 1999-0123-0101)',
        text9: 'Copie de projection',
        text10: {
            placeholder: 'Sélectionner un type de copie',
            option1: '35mm',
            option2: '16mm',
            option3: 'DCP',
        },
        text11: 'Dates de projection',
        text12: 'Première projection',
        text13: 'Dernière projection',
    },
    formReleaseOrder3: {
        text1: "Merci de renseigner les coordonnées de destination des copies<br><br>" +
            "<b>Pour la Suisse:</b><br>" +
            "Les copies sont expédiées au minimum 10 jours avant la première date de projection, par envoi postal contre signature.",
        text2: "La facturation est faite le mois suivant la dernière projection.<br><br>" +
            "Tarifs H.T.<br>" +
            "· Frais de mouvement: CHF 100.- par copie<br><br>" +
            "Frais d'envoi H.T.:<br>" +
            "· CHF 50.- par copie<br>" +
            "· Un envoi Express est majoré de CHF 20.- par copie",
    },
    formReleaseOrder4: {
        text1: 'Remarques',
    },
    formReleaseOrder5: {
        text1: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d07, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs de mise \u00E0 disposition pour d\u00E9posants</a> *"),
        text2: 'Envoyer la demande',
    },
    formReleaseOrder6: {
        text1: 'Nombre de films pour la sortie',
        text2: 'Un maximum de 10 films peuvent être sélectionnés pour une sortie.',
    },
    formMaterialAccess: {
        text1: 'Accès au matériel',
    },
    formMaterialAccess1: {
        text1: 'Motif de la demande',
        text2: 'Descriptif de la demande',
        text3: 'Si nécessaire, faites une brève description de votre demande.<br><br>Le délai de traitement minimum est de 10 jours ouvrés.',
    },
    formMaterialAccess2: {
        text1: 'Fonds ou versement concerné',
        text2: 'Référence(s) (ex. Meier Hans 2020)',
        text3: 'Film concerné',
        text4: 'Prénom réalisateur·rice',
        text5: 'Nom réalisateur·rice',
        text6: 'Titre original / titre français *',
        text7: 'Version linguistique (ex. E/df)',
        text8: 'Cote CS si connue (ex. 1999-0123-0101)',
        text9: 'Type d’élément(s)',
        text10: {
            option1: 'Copie de projection',
            option2: 'Élement de tirage',
            option3: 'Copie d’archive',
            option4: 'Autre',
        },
        text11: 'Si Autre, préciser le type d’élément',
        text12: 'Les éventuelles sorties de matériel pourront être organisées par la suite, en fonction des besoins.',
    },
    formMaterialAccess3: {
        text1: 'Remarques',
    },
    formMaterialAccess4: {
        text1: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d07, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs de mise \u00E0 disposition pour d\u00E9posants</a> *"),
        text2: 'Envoyer la demande',
    },
    formMaterialAccess5: {
        text1: "Un devis vous sera adressé si nécessaire.<br><br>" +
            "Nous ne fournirons aucune prestation payante sans un accord préalable de votre part.<br><br>" +
            "Pour les client·e·s hors Suisse, les paiements s'effectuent d'avance, sur facture.",
    },
    formProjectionCopy: {
        text1: 'Demande de copie de projection',
    },
    formProjectionCopy1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande de copies des collections Film',
        text4: 'Pour chaque film recherché, spécifier:\n- Réalisateur·rice\n- titre original ou titre français\n- année de production',
        text5: 'Si nécessaire, faites une brève description de votre projet.<br><br><b>Pour la Suisse :</b><br>Le délai de traitement minimum est de 10 jours ouvrés.<br><br><b>Pour l’étranger :</b><br>Le délai de traitement minimum est de 40 jours ouvrés.',
    },
    formProjectionCopy2: {
        text1: 'Film recherché',
        text2: 'Prénom réalisateur·rice',
        text3: 'Nom réalisateur·rice',
        text4: 'Titre original / titre français *',
        text5: 'Dates de projection',
        text6: 'Première projection (délai minimum: 10 jours) *',
        text7: 'Dernière projection *',
        text8: 'Nombre de projections',
        text9: 'Dates provisoires',
        text10: '',
        text11: 'Année de production',
    },
    formProjectionCopy3: {
        text1: 'Version linguistique souhaitée',
        text2: 'Support de projection souhaitée',
        text3: {
            option1: 'Copie 35 mm de projection',
            option2: 'DCP - Cinéma numérique',
            option3: 'Blu-ray ou fichier de projection numérique',
        },
        text4: 'Pour les films hors catalogue de diffusion, la disponibilité d’un support de projection n’est pas garantie.<br><br>Les copies 35mm seront proposées en fonction de critères techniques et visuels mimimaux, sans garantie quant à la qualité de projection.<br><br>La Cinémathèque suisse n’effectue pas de numérisations ni de transcodage sur demande.',
        text5: {
            label: 'Version linguistique',
            placeholder: 'Sélectionner une version',
            option1: 'VO s-t. Français',
            option2: 'VO s-t. Allemand',
            option3: 'VO s-t. Italien',
            option4: {
                label: 'Autre version linguistique',
                text1: 'Autre version',
                text2: 'Veuillez préciser *',
            }
        }
    },
    formProjectionCopy4: {
        text1: 'Lieu de projection',
        text2: 'Nom du cinéma / établissement *',
        text3: 'Pays de projection',
        text4: 'Type d’entrées prévu',
        text5: {
            option1: 'Entrées  payantes',
            option2: 'Entrées gratuites',
            option3: 'Festival',
        },
    },
    formProjectionCopy5: {
        text1: 'Matériel de promotion imprimé',
        text2: {
            option1: 'Affiches B1',
            option2: 'Flyers A5',
        },
        text3: 'Quantité',
        text4: 'Pour les films au catalogue de diffusion, avez-vous besoin de matériel de promotion imprimé (sous réserve de disponibilité) ?<br><br>Attention, la demande de matériel imprimé concerne uniquement les films au catalogue de diffusion : <a href="https://www.cinematheque.ch/services/films-en-diffusion" target="_blank">www.cinematheque.ch/diffusion</a>.',
    },
    formProjectionCopy6: {
        text1: 'Remarques',
    },
    formProjectionCopy7: {
        text1: "J\u2019ai bien pris connaissance du <a href=\"".concat(getUrl(urls.docs.d01, FR), "\" target=\"_blank\">\uD83D\uDDCER\u00E8glement et tarifs d\u2019acc\u00E8s aux copies de films</a> *"),
        text2: "J\u2019ai bien pris connaissance du <a href=\"".concat(getUrl(urls.docs.d08, FR), "\" target=\"_blank\">\uD83D\uDDCETarifs des films au catalogue de diffusion</a> *"),
        text3: 'Envoyer la demande',
    },
    formProjectionCopy8: {
        text1: "<b>Pour la Suisse:</b><br>" +
            "∙ Les copies sont expédiées au minimum 10 jours avant la première date de projection, par Poste normale avec signature.<br>" +
            "∙ Un envoi Express est majoré de CHF 20.- H.T. par copie.<br><br>" +
            "<b>Pour l'étranger:</b><br>" +
            "∙ L'organisation du transport et de la douane ainsi que les frais liés sont à la charge du demandeur.",
    },
    formProjectionCopy9: {
        text1: "<b>Pour la Suisse:</b><br>" +
            "∙ La facturation est faite le mois suivant la dernière date de projection.<br><br>" +
            "<b>Pour l'étranger:</b><br>" +
            "∙ Un paiement d'avance sur facture sera exigé avant que la copie ne soit libérée pour le transporteur.<br>" +
            "∙ Les frais de douanes et de transport sont à la charge du demandeur.<br>",
    },
    formProjectionCopy10: {
        text1: "<b>Pour la Suisse :</b><br>Les droits des titres au catalogue de diffusion pourront être réglés directement auprès de la Cinémathèque suisse.",
        text2: "<b>Pour l’étranger :</b><br>Sinon, il vous sera demandé de fournir l’accord préalable des ayants-droit avant toute sortie de matériel.",
    },
    formPromotionalMaterial: {
        text1: 'Diffusion - commande de matériel promotionnel',
    },
    formPromotionalMaterial1: {
        text1: 'Film recherché',
        text2: 'Prénom réalisateur·rice',
        text3: 'Nom réalisateur·rice',
        text4: 'Titre original / titre français *',
    },
    formPromotionalMaterial2: {
        text1: 'Matériel de promotion imprimé',
        text2: {
            option1: 'Affiches B1',
            option2: 'Flyers A5',
        },
        text3: 'Quantité',
        text4: 'Le matériel de promotion numérique pour les films au catalogue de diffusion est librement accessible sur : <a href="https://www.cinematheque.ch/services/films-en-diffusion" target="_blank">cinematheque.ch/services/films-en-diffusion</a>.',
    },
    formPromotionalMaterial3: {
        text1: 'Date de livraison souhaitée *',
        text2: 'Délai minimum de 10 jours ouvrés.',
    },
    formPromotionalMaterial4: {
        text1: 'Remarques',
    },
    formPromotionalMaterial5: {
        text1: 'Envoyer la demande',
    },
    formPromotionalMaterial6: {
        text1: "Les frais d'envoi et de matériel sont pris en charge par la Cinémathèque Suisse dans le cadre des projections organisées en Suisse par son intermédiaire.<br><br>" +
            "Pour tout autre usage, des frais de 15.- CHF TTC par affiche, de 0.20 CHF TTC par flyer et des frais de livraison de 11.- CHF TTC par envoi seront facturées.<br><br>" +
            "Toute prestation payante ne sera fournie qu'après confirmation préalable de votre part.",
    },
    formRoomRental: {
        text1: 'Demande de location',
        conditions: {
            general: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d14, FR), "\" target=\"_blank\">\uD83D\uDDCEConditions g\u00E9n\u00E9rales de location de salle</a>*"),
            cinematographe: 'J’ai bien pris connaissance des <a href="" target="_blank">🗎Conditions générales d’utilisation</a>*',
            capitole: 'J’ai bien pris connaissance des <a href="" target="_blank">🗎Conditions générales d’utilisation</a>*',
        },
        submit: 'Envoyer la demande',
    },
    formRoomRental1: {
        text1: 'Type de location *',
        text2: {
            option1: 'Projection privée',
            option2: 'Projection scolaire',
        },
        text3: 'Vous avez choisi de fournir votre propre support de projection.<br><br>🠚 Vous vous engagez à régler les droits de projection directement auprès de l’ayant-droit et à nous en transmettre l’autorisation au plus tard 10 jours ouvrés avant la date de projection.<br><br>🠚 Vous vous engagez à faire parvenir le support de projection à la Cinémathèque suisse au plus tard 10 jours avant la date de projection - à l’adresse suivante :<br><br><b>Cinémathèque suisse<br>André Schäublin<br>Chemin de la Vaux 1<br>CH-1303 Penthaz</b><br><br><b>Si la Cinémathèque suisse ne reçoit pas l’autorisation ou le support dans les délais impartis, elle se réserve le droits d’annuler la location et d’exiger des frais de dédite.</b><br><br>En cas d’annulation par l’utilisateur·rice moins de 10 jours ouvrés avant la date de location, une dédite de CHF 200.- au minimum (ou 10% du montant de la location) sera facturée.',
    },
    formRoomRental2: {
        text1: 'Salle de projection souhaitée *',
        text2: {
            option1: 'Cinématographe',
            option2: 'Capitole',
        },
        text3: 'Le cinéma Capitole n’est actuellement pas disponible pour les locations, suite aux travaux de rénovation ayant lieu jusqu’à fin 2023.',
    },
    formRoomRental3: {
        text1: 'Date souhaitée *',
        text2: 'Horaire souhaité',
        text3: 'Délai minimal de 2 mois entre le dépôt d’une demande et la 1ère date de location.<br><br><b>Horaires des location</b><br>Sous réserve<br><br><b>Cinématographe<br>Casino de Montbenon<br>3 Allée Ernest-Ansermet<br>1003 Lausanne</b><br><br>Du lundi au samedi<br>9:00 - 12:00<br><br>Mardi et mercredi<br>12:00 - 20:00<br><br>Dimanche et jours fériés<br>Fermé<br><br><b>Capitole</b><br>Indisponible : travaux de rénovation jusqu’à fin 2023.',
    },
    formRoomRental4: {
        text1: 'Remarques',
    },
    formRoomRental6: {
        text1: 'Fréquentation estimée *',
    },
    formRoomRental7: {
        text1: "Aucune prestation payante ne sera fournie sans une confirmation préalable de votre part.<br><br>" +
            "Pour les client·e·s hors Suisse, les paiements s'effectuent d'avance, sur facture",
    },
    formRoomRentalFilm: {
        text1: 'Demande de location',
        conditions: {
            general: "J\u2019ai bien pris connaissance des <a href=\"".concat(getUrl(urls.docs.d14, FR), "\" target=\"_blank\">\uD83D\uDDCEConditions g\u00E9n\u00E9rales de location de salle</a>*"),
            cinematographe: 'J’ai bien pris connaissance des <a href="" target="_blank">🗎Conditions générales d’utilisation</a>*',
            capitole: 'J’ai bien pris connaissance des <a href="" target="_blank">🗎Conditions générales d’utilisation</a>*',
        },
        submit: 'Envoyer la demande',
        text2: 'Votre demande sera notamment examinée selon la nature de la manifestation et la disponibilité des salles',
        text3: 'Descriptif de la manifestation',
        text4: 'Apéritif envisagé *',
        text5: 'Début de la manifestation',
        text6: 'Fin de la manifestation',
        text7: 'Salle historique dont la rénovation s\'est achevée en février 2024, la salle Freddy Buache se déploie sur deux niveaux. Composée d\'un parterre de 578 places et d\'un balcon de 140 places, la salle Freddy Buache ouvre sur deux espaces bar entièrement équipés pouvant accueillir 300 personnes au maximum.',
        text8: 'Salle contemporaine à la rénovation du bâtiment achevée en février 2024, la salle Lucienne Schnegg comprend un petit espace caisse/bar, un foyer pouvant accueillir 80 personnes ainsi qu\'un "forum" de 12 personnes. Trois colonnes d\'affichage digital habillent le foyer et le forum est également équipé d\'un écran exploitable.<br> La salle Lucienne Schnegg est accessible depuis l’entrée principale ou – si nécessaire de rendre la salle indépendante – depuis l’impasse située entre la Coop et le Capitole (l\'utilisation de l’ascenseur n\'est dans ce cas pas possible).'
    },
    formRoomRentalFilm1: {
        text1: 'Film souhaité',
        text2: 'Prénom réalisateur·rice',
        text3: 'Nom réalisateur·rice',
        text4: 'Titre original / titre français *',
        text5: 'Vous avez choisi de combiner votre demande de location avec le prêt d’une copie de projection des collections de la Cinémathèque suisse.<br><br>🠚 Vous pouvez choisir un titre parmi les films du <a href="https://www.cinematheque.ch/services/films-en-diffusion" target="_blank">catalogue de diffusion</a>, pour lesquels la Cinémathèque détient les droits et met à disposition des copies de projection au format numérique.<br><br>🠚 Vous pouvez également indiquer le(s) titre(s) que vous souhaitez projeter, hors catalogue de diffusion.<ul><li>Nous ferons une recherche dans nos collections Film (copies 35mm ou numériques).</li><li>Nous vous informerons des copies projetables disponibles.</li><li>Vous vous engagez à régler les droits de projection directement auprès de l’ayant-droit.</li><li>Si aucune copie n’est disponible, vous serez invité à choisir d’autres titres.</li></ul>',
    },
    formRoomRentalFilm2: {
        text1: 'Type de location *',
        text2: {
            option1: 'Projection privée',
            option2: 'Projection scolaire',
            option3: 'Projection publique',
            option4: 'Autre événement',
        },
    },
    formRoomRentalFilm3: {
        text1: 'Salle de projection souhaitée *',
        text2: {
            // option1: 'Cinématographe',
            // option2: 'Capitole',
            option3: 'Capitole, Salle Freddy Buache',
            option3_below: '718 places',
            option4: 'Capitole, Salle Lucienne Schnegg',
            option4_below: '136 places',
        },
        text3: 'Le cinéma Capitole n’est actuellement pas disponible pour les locations, suite aux travaux de rénovation ayant lieu jusqu’à fin 2023.',
    },
    formRoomRentalFilm4: {
        text1: 'Date souhaitée *',
        text3: 'Prévoir un délai de 60 jours entre le dépôt d’une demande et la date de location.',
    },
    formRoomRentalFilm5: {
        text1: 'Remarques',
    },
    formRoomRentalFilm6: {
        text1: 'J’ai bien pris connaissance des <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Conditions générales d’utilisation</a>',
        text2: 'J’ai bien pris connaissance des <a href="https://www.cinematheque.ch/sites/default/files/2022-12/D12_Conditions_location_salles_2022.pdf" target="_blank">🗎Conditions générales d’utilisation</a>',
        text3: 'Envoyer la demande',
    },
    formRoomRentalFilm7: {
        text1: "Aucune prestation payante ne sera fournie sans une confirmation préalable de votre part.<br><br>" +
            "Pour les client·e·s hors Suisse, les paiements s'effectuent d'avance, sur facture",
    },
    formPartnershipRequest: {
        text1: 'Demande de partenariat',
    },
    formPartnershipRequest1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande *',
        text4: 'Descriptif général de votre demande, date(s) souhaitée(s), thématique(s) et/ou film(s)',
        text5: 'La Cinémathèque suisse collabore actuellement avec de nombreuses institutions et festivals tout au long de l’année.<br><br>Votre demande sera notamment examinée en fonction de la nature de la manifestation proposée et des disponibilités des salles.',
    },
    formPartnershipRequest2: {
        text1: 'Public cible',
        text2: {
            option1: 'Tout public',
            option2: 'Jeune public',
        },
        text3: 'A quel public serait destinée votre manifestation ?',
        text4: 'Médiation culturelle',
        text5: {
            option1: 'Oui',
            option2: 'Non',
        },
        text6: 'Envisagez-vous des activités de médiation culturelle lors de l’événement ? (activités pour enfants, groupes scolaires, etc...).',
        text7: 'Descriptif des activités',
        text8: 'Si "Oui", décrire brièvement les activités envisagées *',
    },
    formPartnershipRequest3: {
        text1: 'Remarques',
    },
    formPartnershipRequest4: {
        text1: 'Envoyer la demande',
    },
    formVisitBooking: {
        text1: 'Visite du Centre de recherche et d’archivage de Penthaz',
    },
    formVisitBooking1: {
        text1: 'Type de visite *',
        text2: {
            option1: 'Visite classique',
            option2: 'Visite magique (7-11 ans)',
        },
        text3: 'Sélectionnez un type de visite pour en voir la description.<br><br>Les visites guidées sont prises en charge par les collaborateurs et collaboratrices de la Cinémathèque suisse qui - en parallèle de leur travail - interviennent tour à tour en présentant les différents départements. Pour cette raison, nous organisons au maximum une visite par semaine et nous vous invitons à nous faire parvenir votre demande le plus tôt possible.<br><br>Les visites guidées font partie du programme de médiation culturelle proposée par la Cinémathèque suisse et sont gratuites.',
    },
    formVisitBooking2: {
        text1: 'Date de visite souhaitée *',
        text2: 'Horaire souhaité',
        text3: 'Délai minimal de 3 mois entre le dépôt d’une demande et la date de visite souhaitée.<br><br><b>Centre de recherche et d’archivage<br>Chemin de la Vaux 1<br>CH-1303 Penthaz</b><br><br><b>Horaires des visites</b><br><br><b>Visites classiques</b><br>Du lundi au vendredi<br>9:00 - 12:00 / 14:00 - 17:00<br><br><b>Visites magiques</b><br>Deux fois par mois, le lundi à convenir.<br><br>Les places de parking étant limitées, nous vous conseillons de privilégier les transports publics, la Cinémathèque suisse se trouve à 15 minutes à pied de la gare de Cossonay-Penthalaz.',
        text4: {
            option1: 'Le matin',
            option2: 'L’après-midi',
        }
    },
    formVisitBooking3: {
        text1: 'Information sur les visiteurs',
        text2: 'Brève description du groupe *',
    },
    formVisitBooking4: {
        text1: 'Nombre de personnes (30 maximum) *',
        text2: 'Nombre',
        text3: 'Tranche d’âge',
        text4: {
            option1: '7-11 ans',
            option2: '12-15 ans',
            option3: '15-18 ans',
            option4: 'Tout public',
        },
        text5: 'Avez-vous des attentes ou souhaits spécifiques lors de votre visite ?',
        text6: 'Descriptif',
        text7: 'Besoins spécifiques',
        text8: {
            option1: 'Parcours avec assise régulière',
            option2: 'Parcours sans escaliers',
        },
    },
    formVisitBooking5: {
        text1: 'Remarques',
        text2: 'Avez-vous d’éventuelles remarques à propos de votre demande ?',
    },
    formVisitBooking6: {
        text1: 'Envoyer la demande',
    },
    formFilmScreening: {
        text1: 'Assister à une projection - Groupe',
    },
    formFilmScreening1: {
        text1: 'Nombre de personnes (10 minimum) *',
        text2: 'Nombre',
        text3: 'Société / Entreprise / Privé',
        text4: 'Nom de société / établissement',
        text5: 'La réservation de groupe est possible uniquement en dehors des séances spéciales et des avant-prémières, à partir de 10 personnes.<br><br>Après réception d’une confirmation de réservation, vous pourrez retirer et régler vos billets directement à la caisse du cinéma, lors des horaires d’ouverture ou au plus tard 10 minutes avant la séance. Passé ce délai, nous ne garantissons plus votre réservation et vos places seront remises en vente.',
    },
    formFilmScreening2: {
        text1: 'Date de la séance souhaitée *',
        text2: 'Horaire de la séance souhaitée *',
        text3: 'Le programme des projections est consultable sur :<br><a href="https://live.cinematheque.ch/" target="_blank">live.cinematheque.ch</a>',
    },
    formFilmScreening3: {
        text1: 'Remarques',
        text2: 'Avez-vous d’éventuelles remarques à propos de votre demande ?',
    },
    formFilmScreening4: {
        text1: 'Envoyer la demande',
    },
    formSchoolFilmScreening: {
        text1: 'Assister à une projection - Groupe scolaire',
    },
    formSchoolFilmScreening1: {
        text1: 'Établissement scolaire *',
        text2: 'Nom du gymnase / établissement scolaire',
        text3: 'Nombre d’élèves *',
        text4: 'Nombre',
        text5: 'Nombre d’accompagnants *',
        text6: 'Nombre',
        text7: 'Canton',
        text8: 'Tranche d’âge',
        text9: {
            option1: '7-11 ans',
            option2: '12-15 ans',
            option3: '15-18 ans',
            option4: '18 ans et +',
        },
        text10: 'La réservation pour groupe scolaire est possibles uniquement en dehors des séances spéciales et des avant-prémières.<br><br>Après réception d’une confirmation de réservation, vous pourrez retirer et régler vos billets directement à la caisse du cinéma, lors des horaires d’ouverture ou au plus tard 10 minutes avant la séance. Passé ce délai, nous ne garantissons plus votre réservation et vos places seront remises en vente.<br><br>Afin d’accélérer la procédure en caisse, merci de vous y présenter avec une liste imprimée comprenant les noms des étudiants et accompagnants assistant à la séance.',
    },
    formSchoolFilmScreening2: {
        text1: 'Date de la séance souhaitée *',
        text2: 'Horaire de la séance souhaitée *',
        text3: 'Le programme des projections est consultable sur :<br><a href="https://www.cinematheque.ch/" target="_blank">www.cinematheque.ch</a>',
    },
    formSchoolFilmScreening3: {
        text1: 'Remarques',
        text2: 'Avez-vous d’éventuelles remarques à propos de votre demande ?',
    },
    formSchoolFilmScreening4: {
        text1: 'Envoyer la demande',
    },
    formMaterialDeposit: {
        text1: 'Donner ou déposer du matériel',
        conditions: "Le mat\u00E9riel est conforme aux <a href=\"".concat(getUrl(urls.docs.d12, FR), "\" target=\"_blank\">\uD83D\uDDCESp\u00E9cifications techniques pour le d\u00E9p\u00F4t obligatoire d\u2019\u00E9l\u00E9ments de film num\u00E9riques</a> (version italienne disponible <a href=\"").concat(getUrl(urls.docs.d12, Langs.it), "\" target=\"_blank\">\uD83D\uDDCEici</a>)"),
    },
    formMaterialDeposit1: {
        text1: 'Titre de la demande *',
        text2: 'Titre de votre demande',
        text3: 'Détails sur la demande',
        text4: 'Motif de la proposition de versement',
        text5: "Suite \u00E0 l\u2019envoi de votre demande, la Cin\u00E9math\u00E8que suisse examinera votre proposition dans les meilleurs d\u00E9lais et prendra contact avec vous.<br><br>En vertu de la <a href=\"".concat(getUrl(urls.docs.d09, FR), "\" target=\"_blank\">\uD83D\uDDCEPolitique de collection</a> et des <a href=\"").concat(getUrl(urls.docs.d10, FR), "\" target=\"_blank\">\uD83D\uDDCEModalit\u00E9s de d\u00E9p\u00F4ts num\u00E9riques</a> \u00E0 la Cin\u00E9math\u00E8que suisse,  il est possible que des propositions de don ou de d\u00E9p\u00F4t soient refus\u00E9es, en partie ou dans leur totalit\u00E9."),
    },
    formMaterialDeposit2: {
        text1: 'Type de versement concerné',
        text2: {
            option1: 'Dépôt',
            option2: 'Don',
        },
        text3: 'Pouvez-vous fournir un inventaire pour le versement concerné ?',
        text4: {
            option1: 'Oui',
            option2: 'Non',
        },
        text5: 'Le don implique le transfert de la propriété des documents et objets à la Cinémathèque suisse.',
    },
    formMaterialDeposit3: {
        text1: 'Types d’objets concernés par le versement',
        text2: {
            option1: 'Films : pellicule, fichiers numériques, supports de données, etc.',
            option2: 'Objets iconographiques : photographies, affiches, etc.',
            option3: 'Appareils cinématographiques',
            option4: 'Archives papier',
        },
        text3: 'Détails',
        text4: 'Types de supports, titre des oeuvres...',
        text5: 'Description des objets iconographiques',
        text6: 'Description des appareils cinématographiques',
        text7: 'Volumétrie approximative',
        text8: 'Estimation',
        text9: 'La Cinémathèque suisse se réserve le droit de faire un premier tri et de ne pas conserver les éléments inutilisables, trop dégradés et/ou présentant un danger pour la collection.<br><br>Pour les films, merci de préciser dans les détails les types de supports, titre des oeuvres, réalisateur·rice, année de production, ayant-droits, provenance, documentation disponible, etc.<br><br>Pour la volumétrie : merci de renseigner une estimation en m3 , poids (kilos), éventuellement le nombre de palettes (euro).',
    },
    formMaterialDeposit4: {
        text1: 'Remarques',
        text2: 'Avez-vous d’éventuelles remarques à propos de votre demande ?',
    },
    formMaterialDeposit5: {
        text1: 'Envoyer la demande',
    },
    formMaterialDeposit6: {
        text1: "<b>Merci de ne pas transmettre de matériel à la Cinémathèque suisse tant que nous n'aurons pas validé votre demande.</b>",
    },
    formVisitBookingZh: {
        text1: "Visite du Centre de recherche et d’archivage de Zurich",
    },
    formVisitBookingZh1: {
        text1: 'Date de visite souhaitée',
        text2: 'Horaire souhaitée',
        text3: {
            option1: 'Matin',
            option2: 'Après-midi',
        },
        text4: 'Délai minimal de 1 semaine entre le dépôt d’une demande et la date de visite souhaitée.<br><br><b>Forschungs- und Archivierungszentrum<br>Neugasse 10<br>CH-8005 Zürich</b><br><br><b>Horaires des visites</b><br>Du lundi au jeudi<br>9:00 - 12:30 / 13:30 - 17:00<br><br>Vendredi fermé',
    },
    formVisitBookingZh2: {
        text1: 'Nombre de personnes *',
        text2: 'Nombre',
        text3: 'Information sur les visiteurs *',
        text4: 'Brève description du groupe',
    },
    formVisitBookingZh3: {
        text1: 'Avez-vous des attentes ou souhaits spécifiques lors de votre visite ?',
        text2: 'Descriptif',
    },
    formVisitBookingZh4: {
        text1: 'Remarques',
        text2: 'Avez-vous d’éventuelles remarques à propos de votre demande ?',
    },
    formVisitBookingZh5: {
        text1: 'Envoyer la demande',
    },
    forms: {
        'projection-copy': 'Demande de copie(s) de projection',
        'clip-request': 'Demande d’extrait(s)',
        'viewing-request': 'Demande de visionnement',
        'release-order': 'Ordre de sortie',
        'material-access': 'Accès au matériel',
        'cine-journal': 'Licence et matériel vidéo du Ciné-Journal suisse',
        'on-site-consultation': 'Demande de consultation sur place, de rendez-vous ou de renseignement',
        'still-images': 'Demande d’image(s) fixe(s)',
        'promotional-material': 'Diffusion - commande de matériel promotionnel',
        'film-screening': 'Assister à une projection - Groupe',
        'school-film-screening': 'Assister à une projection - Groupe scolaire',
        'partnership-request': 'Demande de partenariat',
        'room-rental': 'Demande de location',
        'rental-request': 'Demande de location',
        'room-rental-film': 'Demande de location avec copie de film',
        'visit-booking': 'Visite du Centre de recherche et d’archivage de Penthaz',
        'visit-booking-zh': 'Visite du Centre de recherche et d’archivage de Zurich',
        'information-request': 'Demande d’informations sur les collections',
        'material-deposit': 'Donner ou déposer du matériel',
    },
    formList: {
        title: 'Liste des formulaires',
        callToAction: 'Cliquez sur le formulaire correspondant à votre type de demande:',
        headers: {
            section1: 'Collections Film',
            section2: 'Collections Non-Film',
            section3: 'Médiation et programme',
            section4: 'Ressources générales',
        },
        section1: {
            link1: 'Demande de copie(s) de projection',
            link2: 'Demande d’extrait(s)',
            link3: 'Demande de visionnement',
            link4: 'Déposant: Ordre de sortie pour projection',
            link5: 'Déposant: Accès au matériel déposé',
            link6: 'Licence et matériel vidéo du Ciné-Journal suisse',
        },
        section2: {
            link1: 'Demande de consultation sur place',
            link2: 'Demande d’image(s) fixe(s)',
            link3: 'Diffusion: commande de matériel promotionnel',
        },
        section3: {
            link1: 'Assister à une projection - Groupe',
            link2: 'Assister à une projection - Groupe scolaire',
            link3: 'Demander un partenariat',
            link4: 'Louer une salle de projection',
            link5: 'Visiter le Centre de recherche et d’archivage de Penthaz',
            link6: 'Visiter le Centre de recherche et d’archivage de Zurich',
        },
        section4: {
            link1: "Demande d’informations sur les collections",
            link2: "Donner ou déposer du matériel",
        },
    },
    visits: {
        visit1: {
            img: 'https://www.cinematheque.ch/typo3temp/_processed_/csm_3_2fd94e_1191404542.jpg',
            p1: '<b>La visite classique (tout public)</b><br>Fréquence: 2 fois par mois',
            p2: 'Pensée pour un large public, la visite classique offre une vue d’ensemble des travaux et missions de la Cinémathèque suisse : en plus d’une brève projection, les collaboratices et collaborateurs présenteront les différents enjeux liés à la conservation et à la restauration, suivant un parcours des locaux d’environ deux heures.',
        },
        visit2: {
            img: 'https://www.cinematheque.ch/typo3temp/_processed_/csm_3_e7861e_7c4a4769b5.jpg',
            p1: '<b>La visite magique (7-11 ans)</b><br>Fréquence: 1 lundi chaque 2 semaines (TBC)',
            p2: 'Cette visite d’une heure et demie offre une introduction ludique qui permettra aux enfants de découvrir le monde des archives et d’avoir un aperçu du rôle de la Cinémathèque suisse et du type de travaux effectués par ses équipes (conservation, restauration, etc.). Le programme prévoit des moments d’échanges, une brève projection, ainsi que des ateliers autour du cinéma des premiers temps et du film d’animation.',
        },
    },
    rooms: {
        room1: {
            img: 'https://www.cinematheque.ch/sites/default/files/2022-12/Cin%C3%A9matographe_Salle%20de%20projection_Casino%20de%20Montbenon.jpg',
            p1: '<b>Fiche technique du Cinématographe</b><br>État au 1er mai 2017',
            p2: 'Nombre de places assises : 101<br>Dimensions : 13m × 6m',
            p3: '<b>Écran</b><br>Dimensions : 4,65m × 2,13m',
            p4: '<b>Matériel de projection</b><br>Projecteur 35mm : 2× Cinemeccanica VictoriaProjecteur 16mm : 1× Prevost double-bande<br>Projecteur vidéo : 1× Barco DP4K-32B',
            p5: '<b>Matériel de lecture</b><br>Lecteur Beta : 1× SONY Betacam J-30 (SP / SX / Digital / MPEG IMX) (5× Analogique – 5× BNC)<br>Lecteur Blu-Ray : 1× OPPO Blu-Ray BDP-103 (Clés USB mpeg4 H264 50m bitrate limite)<br>Lecteur DVCAM+MiniDV : 1× SONY DVCAM+MiniDV (HDV 1080i / HDMI Prog / DV)<br>(60i-30p-24p-30i-25p)<br>Serveur : 1× Doremi DCP-2000',
            p6: '<b>Son et autres</b><br>DOLBY CP650 (Dolby 5.1)<br>Ampli JPA (boucle malentendants) 3 micros sans fil (Sennheiser)<br>2 micros avec fil (Sennheiser) 1 micro-table (JTS)',
            p7: '<b>Accessoires</b><br>1 piano (Sauter)',
            p8: '<b>Entrées sur la scène</b><br>1 boîtier d’entrée image HDMI et VGA 6 entrées XLR<br>1 entrée RJ45 (connexion internet)',
            p9: '<b>Accès handicapés</b><br>Accès salle : pour 1 personne (prévenir à l’avance)<br>Accès WC : oui',
        },
    },
    customerProfileShow: {
        text1: 'Mon profil',
    },
    customerProfileShow1: {
        text1: "Nom d'utilisateur·rice",
        text2: 'E-mail',
        text3: {
            label: 'Status FIAF',
            status1: 'Membre FIAF',
            status2: 'non-membre',
        },
        text4: 'Téléphone',
        text5: 'Adresse de livraison',
        text6: 'Adresse de facturation',
        deliveryAddress: {
            text1: 'Pays',
            text2: 'Ville',
            text3: 'Rue',
            text4: 'Entreprise',
        },
        billingAddress: {
            text1: 'Pays',
            text2: 'Ville',
            text3: 'Rue',
            text4: 'Entreprise',
        }
    },
    customerProfileShow2: {
        text1: "Modifier mon e-mail / Mot de passe",
    },
    cantons: {
        AG: 'Argovie',
        AI: 'Appenzell Rhodes-Intérieures',
        AR: 'Appenzell Rhodes-Extérieures',
        BE: 'Berne',
        BL: 'Bâle-Campagne',
        BS: 'Bâle-Ville',
        FR: 'Fribourg',
        GE: 'Genève',
        GL: 'Glaris',
        GR: 'Grisons',
        JU: 'Jura',
        LU: 'Lucerne',
        NE: 'Neuchâtel',
        NW: 'Nidwald',
        OW: 'Obwald',
        SG: 'Saint-Gall',
        SH: 'Schaffhouse',
        SO: 'Soleure',
        SZ: 'Schwytz',
        TG: 'Thurgovie',
        TI: 'Tessin',
        UR: 'Uri',
        VD: 'Vaud',
        VS: 'Valais',
        ZG: 'Zoug',
        ZH: 'Zurich',
    },
    countries: {
        AF: 'Afghanistan',
        AL: 'Albanie',
        DZ: 'Algérie',
        AS: 'Samoa américaines',
        AD: 'Andorre',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctique',
        AG: 'Antigua-et-Barbuda',
        AR: 'Argentine',
        AM: 'Arménie',
        AW: 'Aruba',
        AU: 'Australie',
        AT: 'Autriche',
        AZ: 'Azerbaïdjan',
        BS: 'Bahamas',
        BH: 'Bahreïn',
        BD: 'Bangladesh',
        BB: 'Barbade',
        BY: 'Biélorussie',
        BE: 'Belgique',
        BZ: 'Belize',
        BJ: 'Bénin',
        BM: 'Bermudes',
        BT: 'Bhoutan',
        BO: 'Bolivie',
        BA: 'Bosnie-Herzégovine',
        BW: 'Botswana',
        BV: 'Île Bouvet',
        BR: 'Brésil',
        IO: 'Océan Indien Britannique',
        BN: 'Brunei Darussalam',
        BG: 'Bulgarie',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        KH: 'Cambodge',
        CM: 'Cameroun',
        CA: 'Canada',
        CV: 'Cap-Vert',
        KY: 'Îles Caïmans',
        CF: 'République Centrafricaine',
        TD: 'Tchad',
        CL: 'Chili',
        CN: 'Chine',
        CX: 'Île Christmas',
        CC: 'Îles Cocos',
        CO: 'Colombie',
        KM: 'Comores',
        CG: 'République du Congo',
        CD: 'République démocratique du Congo',
        CK: 'Îles Cook',
        CR: 'Costa Rica',
        CI: 'Côte-d’Ivoire',
        HR: 'Croatie',
        CU: 'Cuba',
        CY: 'Chypre',
        CZ: 'République Tchèque',
        DK: 'Danemark',
        DJ: 'Djibouti',
        DM: 'Dominique',
        DO: 'République Dominicaine',
        EC: 'Équateur',
        EG: 'Égypte',
        SV: 'El Salvador',
        GQ: 'Guinée équatoriale',
        ER: 'Érythrée',
        EE: 'Estonie',
        ET: 'Éthiopie',
        FK: 'Îles Malouines',
        FO: 'Îles Féroé',
        FJ: 'Fidji',
        FI: 'Finlande',
        FR: 'France',
        GF: 'Guyane française',
        PF: 'Polynésie française',
        TF: 'Terres australes françaises',
        GA: 'Gabon',
        GM: 'Gambie',
        GE: 'Géorgie',
        DE: 'Allemagne',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Grèce',
        GL: 'Groenland',
        GD: 'Grenade',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GN: 'Guinée',
        GW: 'Guinée-Bissau',
        GY: 'Guyana',
        HT: 'Haïti',
        HM: 'Îles Heard-et-MacDonald',
        VA: 'Saint-Siège (Vatican)',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hongrie',
        IS: 'Islande',
        IN: 'Inde',
        ID: 'Indonésie',
        IR: 'Iran',
        IQ: 'Irak',
        IE: 'Irlande',
        IL: 'Israël',
        IT: 'Italie',
        JM: 'Jamaïque',
        JP: 'Japon',
        JO: 'Jordanie',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KP: 'Corée du Nord',
        KR: 'Corée du Sud',
        KW: 'Koweït',
        KG: 'Kirghizistan',
        LA: 'Laos',
        LV: 'Lettonie',
        LB: 'Liban',
        LS: 'Lesotho',
        LR: 'Libéria',
        LY: 'Libye',
        LI: 'Liechtenstein',
        LT: 'Lituanie',
        LU: 'Luxembourg',
        MO: 'Macao',
        MK: 'Macédoine du Nord',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaisie',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malte',
        MH: 'Îles Marshall',
        MQ: 'Martinique',
        MR: 'Mauritanie',
        MU: 'Maurice',
        YT: 'Mayotte',
        MX: 'Mexique',
        FM: 'Micronésie',
        MD: 'Moldavie',
        MC: 'Monaco',
        MN: 'Mongolie',
        MS: 'Montserrat',
        MA: 'Maroc',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibie',
        NR: 'Nauru',
        NP: 'Népal',
        NL: 'Pays-Bas',
        NC: 'Nouvelle-Calédonie',
        NZ: 'Nouvelle-Zélande',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigéria',
        NU: 'Niué',
        NF: 'Île Norfolk',
        MP: 'Îles Mariannes du Nord',
        NO: 'Norvège',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palaos',
        PS: 'Palestine',
        PA: 'Panama',
        PG: 'Papouasie-Nouvelle-Guinée',
        PY: 'Paraguay',
        PE: 'Pérou',
        PH: 'Philippines',
        PN: 'Îles Pitcairn',
        PL: 'Pologne',
        PT: 'Portugal',
        PR: 'Porto Rico',
        QA: 'Qatar',
        RE: 'Réunion',
        RO: 'Roumanie',
        RU: 'Russie',
        RW: 'Rwanda',
        SH: 'Sainte-Hélène',
        KN: 'Saint-Christophe-et-Niévès',
        LC: 'Sainte-Lucie',
        PM: 'Saint-Pierre-et-Miquelon',
        VC: 'Saint-Vincent-et-les-Grenadines',
        WS: 'Samoa',
        SM: 'Saint-Marin',
        ST: 'São Tomé-et-Principe',
        SA: 'Arabie Saoudite',
        SN: 'Sénégal',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapour',
        SK: 'Slovaquie',
        SI: 'Slovénie',
        SB: 'Îles Salomon',
        SO: 'Somalie',
        ZA: 'Afrique du Sud',
        GS: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
        ES: 'Espagne',
        LK: 'Sri Lanka',
        SD: 'Soudan',
        SR: 'Suriname',
        SJ: 'Svalbard et Île Jan Mayen',
        SZ: 'Royaume d’Eswatini',
        SE: 'Suède',
        CH: 'Suisse',
        SY: 'Syrie',
        TW: 'Taïwan',
        TJ: 'Tadjikistan',
        TZ: 'République unie de Tanzanie',
        TH: 'Thaïlande',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinité-et-Tobago',
        TN: 'Tunisie',
        TR: 'Turquie',
        TM: 'Turkménistan',
        TC: 'Îles Turques-et-Caïques',
        TV: 'Tuvalu',
        UG: 'Ouganda',
        UA: 'Ukraine',
        AE: 'Émirats Arabes Unis',
        GB: 'Royaume-Uni',
        US: 'États-Unis d’Amérique',
        UM: 'Îles mineures éloignées des États-Unis',
        UY: 'Uruguay',
        UZ: 'Ouzbékistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietnam',
        VG: 'Îles vierges britanniques',
        VI: 'Îles vierges américaines',
        WF: 'Wallis-et-Futuna',
        EH: 'Sahara occidental',
        YE: 'Yémen',
        ZM: 'Zambie',
        ZW: 'Zimbabwe',
        AX: 'Åland',
        BQ: 'Bonaire, Saint-Eustache et Saba',
        CW: 'Curaçao',
        GG: 'Guernesey',
        IM: 'Île de Man',
        JE: 'Jersey',
        ME: 'Monténégro',
        BL: 'Saint-Barthélemy',
        MF: 'Saint-Martin (partie française)',
        RS: 'Serbie',
        SX: 'Saint-Martin (partie néerlandaise)',
        SS: 'Soudan du Sud',
        XK: 'Kosovo',
    },
    validation: __assign({ startBeforeEnd: "La date de première projection est définie après la date de dernière projection", initialDateDelay: "Le délai initial n'est pas respecté", disallowWeekend: "Le samedi et le dimanche ne peuvent pas être sélectionnés", any: "Veuillez sélectionner au moins une des catégories", checked: "" }, (fr.messages))
};
